module.exports = __webpack_public_path__ + "img/expostyle_9302_fushia.7456cab3.jpg";